import React from 'react';
import { Check } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

const SavedThemesManager = ({ themes, onActivate, onDelete }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {themes.map((theme) => (
        <Card key={theme.id} className={theme.isActive ? 'border-2 border-green-500' : ''}>
          <CardHeader>
            <div className="flex justify-between items-start">
              <CardTitle className="text-lg">{theme.name}</CardTitle>
              {theme.isActive && (
                <span className="flex items-center gap-1 text-xs bg-green-100 text-green-700 px-2 py-1 rounded">
                  <Check className="h-3 w-3" />
                  Aktiv
                </span>
              )}
            </div>
          </CardHeader>
          <CardContent>
            {/* Color Preview */}
            <div className="space-y-3 mb-4">
              <div className="flex items-center gap-2">
                <div className="w-12 h-12 rounded" style={{ backgroundColor: theme.colors.primary }} />
                <div>
                  <p className="text-xs font-medium">Primär</p>
                  <p className="text-xs text-gray-600">{theme.colors.primary}</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-12 h-12 rounded" style={{ backgroundColor: theme.colors.secondary }} />
                <div>
                  <p className="text-xs font-medium">Sekundär</p>
                  <p className="text-xs text-gray-600">{theme.colors.secondary}</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-12 h-12 rounded" style={{ backgroundColor: theme.colors.background }} />
                <div>
                  <p className="text-xs font-medium">Hintergrund</p>
                  <p className="text-xs text-gray-600">{theme.colors.background}</p>
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="flex gap-2">
              {!theme.isActive && (
                <Button
                  onClick={() => onActivate(theme.id)}
                  size="sm"
                  className="flex-1"
                >
                  Aktivieren
                </Button>
              )}
              {theme.id !== 'default-goldbraun' && (
                <Button
                  onClick={() => onDelete(theme.id)}
                  size="sm"
                  variant="outline"
                >
                  Löschen
                </Button>
              )}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default SavedThemesManager;
